import { render, staticRenderFns } from "./Printable.vue?vue&type=template&id=5cf3cc71&"
import script from "./Printable.vue?vue&type=script&lang=js&"
export * from "./Printable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports